import { Injectable } from "@angular/core";
import { BehaviorSubject, Observable } from "rxjs";
import { map, tap } from "rxjs/operators";
import { OrdersCommunicationService } from "src/app/_shared/services/orders.service";
import { RequestsService } from "src/app/_shared/services/requests.service";
import {
  CreatePurchaseOrder,
  PurchaseOrder,
  PurchaseOrderItem,
} from "../purchases/interface";

@Injectable({
  providedIn: "root",
})
export class PurchaseService {
  currentPurchaseOrder: PurchaseOrder;
  currentPurchaseOrder$: BehaviorSubject<PurchaseOrder> = new BehaviorSubject(
    null
  );
  constructor(
    private requestService: RequestsService,
    private orderCommunService: OrdersCommunicationService
  ) {}

  generatePurchaseOrder(
    items: Partial<PurchaseOrder>[],
    purchaseListIds: string[] = []
  ): Observable<CreatePurchaseOrder> {
    const body = {
      purchase_order: items,
      purchase_lists: purchaseListIds,
    };
    return this.requestService
      .dash_post(`purchase-list/generate-purchase-orders`, body)
      .pipe(
        tap((data) => {
          this.orderCommunService.emitChange({
            new: true,
          });
        })
      );
  }
  loadSinglePurchaseOrder(id: string) {
    return this.requestService.dash_get(`purchase-order/${id}`, {}).pipe(
      map((data) => data.data),
      tap((data) => {
        this.currentPurchaseOrder$.next(data);
        this.currentPurchaseOrder = data;
      })
    );
  }

  approvePurchaseOrder(id: string) {
    return this.requestService.dash_patch(`purchase-order/${id}`, {}).pipe(
      tap((data) => {
        this.loadSinglePurchaseOrder(id);
        this.orderCommunService.emitChange({
          new: true,
        });
      })
    );
  }

  sendForApprovePurchaseOrder(id: string, link: string) {
    return this.requestService
      .dash_post(`purchase-order/${id}/send-for-approval`, { link })
      .pipe(
        tap((data) => {
          this.loadSinglePurchaseOrder(id);
          this.orderCommunService.emitChange({
            new: true,
          });
        })
      );
  }

  updatePurchaseOrder(id: string, data: Partial<PurchaseOrder>) {
    return this.requestService.dash_patch(`purchase-order/${id}`, data).pipe(
      tap((data) => {
        this.orderCommunService.emitChange({
          new: true,
        });
      })
    );
  }

  deletePurchaseOrder(id: string) {
    return this.requestService.dash_delete(id, "purchase-order").pipe(
      tap((data) => {
        this.orderCommunService.emitChange({
          new: true,
        });
      })
    );
  }

  getPurchaseOrderReceiveData(id: string) {
    return this.requestService.dash_get(`purchase-order/${id}/receive`, {});
  }

  receivePurchaseOrderStock(id: string, data: PurchaseOrderItem[]) {
    return this.requestService
      .dash_post(`purchase-order/${id}/receive`, data)
      .pipe(
        tap((data) => {
          this.orderCommunService.emitChange({
            new: true,
          });
        })
      );
  }
}
